"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TurmoilHandler = void 0;
const MarsCoalition_1 = require("../cards/community/corporations/MarsCoalition");
const constants_1 = require("../constants");
const DiscardCards_1 = require("../deferredActions/DiscardCards");
const SelectHowToPayDeferred_1 = require("../deferredActions/SelectHowToPayDeferred");
const GlobalParameter_1 = require("../GlobalParameter");
const SelectOption_1 = require("../inputs/SelectOption");
const Resources_1 = require("../Resources");
const Empower_1 = require("./parties/Empower");
const Greens_1 = require("./parties/Greens");
const Kelvinists_1 = require("./parties/Kelvinists");
const MarsFirst_1 = require("./parties/MarsFirst");
const PartyHooks_1 = require("./parties/PartyHooks");
const PartyName_1 = require("./parties/PartyName");
const Populists_1 = require("./parties/Populists");
const Reds_1 = require("./parties/Reds");
const Spome_1 = require("./parties/Spome");
const TurmoilPolicy_1 = require("./TurmoilPolicy");
class TurmoilHandler {
    constructor() { }
    static addPartyActionToActionsList(player, policy, options, title = 'Pay') {
        if (policy.canAct(player)) {
            options.push(new SelectOption_1.SelectOption(policy.description, title, () => policy.action(player)));
        }
    }
    static applyOnCardPlayedEffect(player, selectedCard) {
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.GREENS, TurmoilPolicy_1.TurmoilPolicy.GREENS_POLICY_3)) {
            const policy = Greens_1.GREENS_POLICY_3;
            policy.onCardPlayed(player, selectedCard);
        }
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.MARS, TurmoilPolicy_1.TurmoilPolicy.MARS_FIRST_POLICY_2)) {
            const policy = MarsFirst_1.MARS_FIRST_POLICY_2;
            policy.onCardPlayed(player, selectedCard);
        }
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.POPULISTS, TurmoilPolicy_1.TurmoilPolicy.POPULISTS_POLICY_2)) {
            const policy = Populists_1.POPULISTS_POLICY_2;
            policy.onCardPlayed(player, selectedCard);
        }
    }
    static resolveTilePlacementCosts(player) {
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS, TurmoilPolicy_1.TurmoilPolicy.REDS_POLICY_2)) {
            const redsPolicy = Reds_1.REDS_POLICY_2;
            redsPolicy.onTilePlaced(player);
        }
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.SPOME, TurmoilPolicy_1.TurmoilPolicy.SPOME_POLICY_3)) {
            const spomePolicy = Spome_1.SPOME_POLICY_3;
            spomePolicy.onTilePlaced(player);
        }
    }
    static resolveTilePlacementBonuses(player, space) {
        PartyHooks_1.PartyHooks.applyMarsFirstRulingPolicy(player, space);
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.GREENS, TurmoilPolicy_1.TurmoilPolicy.GREENS_POLICY_2)) {
            const greensPolicy = Greens_1.GREENS_POLICY_2;
            greensPolicy.onTilePlaced(player);
        }
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.KELVINISTS, TurmoilPolicy_1.TurmoilPolicy.KELVINISTS_POLICY_4)) {
            const kelvinistsPolicy = Kelvinists_1.KELVINISTS_POLICY_4;
            kelvinistsPolicy.onTilePlaced(player);
        }
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.EMPOWER, TurmoilPolicy_1.TurmoilPolicy.EMPOWER_POLICY_2)) {
            const empowerPolicy = Empower_1.EMPOWER_POLICY_2;
            empowerPolicy.onTilePlaced(player);
        }
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.POPULISTS, TurmoilPolicy_1.TurmoilPolicy.POPULISTS_POLICY_4)) {
            const populistsPolicy = Populists_1.POPULISTS_POLICY_4;
            populistsPolicy.onTilePlaced(player);
        }
    }
    static onGlobalParameterIncrease(player, parameter, steps = 1) {
        if (parameter === GlobalParameter_1.GlobalParameter.TEMPERATURE) {
            if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.KELVINISTS, TurmoilPolicy_1.TurmoilPolicy.KELVINISTS_POLICY_2)) {
                player.addResource(Resources_1.Resources.MEGACREDITS, steps * 3);
            }
        }
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS, TurmoilPolicy_1.TurmoilPolicy.REDS_POLICY_4)) {
            player.addProduction(Resources_1.Resources.MEGACREDITS, -1 * steps, { log: true });
        }
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.SCIENTISTS, TurmoilPolicy_1.TurmoilPolicy.SCIENTISTS_POLICY_3)) {
            player.drawCard(steps);
            player.game.defer(new DiscardCards_1.DiscardCards(player, steps, 'Turmoil Scientists - Select ' + steps + ' card(s) to discard'));
        }
        if (parameter === GlobalParameter_1.GlobalParameter.VENUS) {
            if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.SPOME, TurmoilPolicy_1.TurmoilPolicy.SPOME_DEFAULT_POLICY)) {
                player.addResource(Resources_1.Resources.MEGACREDITS, steps * 2);
            }
        }
        MarsCoalition_1.MarsCoalition.onGlobalParameterIncrease(player, parameter, steps);
    }
    static handleSocietyPayment(player, partyName) {
        const turmoil = player.game.turmoil;
        if (turmoil !== undefined && turmoil.parties.find((p) => p.name === partyName) === undefined) {
            player.game.defer(new SelectHowToPayDeferred_1.SelectHowToPayDeferred(player, constants_1.SOCIETY_ADDITIONAL_CARD_COST, { title: 'Society: Select how to pay for card' }));
        }
    }
    static randomizeGlobalEventDelegates(turmoil, dealer) {
        const topDelegates = turmoil.parties.map((party) => party.name).reduce((a, i) => a.concat(Array(10).fill(i)), []);
        const bottomDelegates = turmoil.parties.map((party) => party.name).reduce((a, i) => a.concat(Array(10).fill(i)), []);
        dealer.globalEventsDeck.forEach((event) => {
            event.currentDelegate = topDelegates.splice(Math.floor(Math.random() * topDelegates.length), 1)[0];
            event.revealedDelegate = bottomDelegates.splice(Math.floor(Math.random() * bottomDelegates.length), 1)[0];
        });
    }
}
exports.TurmoilHandler = TurmoilHandler;
//# sourceMappingURL=TurmoilHandler.js.map